import { ValueOf } from 'next/dist/shared/lib/constants';
import {
  SearchFilters,
  TableState,
} from 'src/components/DataTable/types/DataTable';

function hasActiveValue(value: ValueOf<SearchFilters>): boolean {
  if (value === undefined || value === null || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return true;
}

export function hasActiveFilters<TFilters>(
  tableState: TableState<TFilters>
): boolean {
  const { page, pageSize, sortField, sortOrder, ...filters } = tableState;

  return Object.values(filters).some(hasActiveValue);
}
